<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" sm="8">
          <b-card no-body class="mx-4 shadow-sm border-0">
            <b-card-body class="p-4 text-center">
              <div class="mb-3">
                <i class="fa fa-key text-primary" style="font-size: 3rem;"></i>
              </div>
              <h2 class="h4 mb-3 font-weight-bold">{{ $t('RecoverYourPassword') || 'Recuperar Contraseña' }}</h2>
              
              <b-alert show variant="info" class="text-left my-4 p-3">
                <div class="d-flex align-items-start">
                  <i class="fa fa-info-circle fa-lg mr-2 mt-1 text-info"></i>
                  <div>
                    <strong>Información de Seguridad:</strong>
                    <p class="mb-0 mt-1 small">
                      Para restablecer su contraseña de acceso a la plataforma, por favor <strong>comuníquese directamente con el administrador del sistema</strong>.
                    </p>
                  </div>
                </div>
              </b-alert>

              <div class="mt-4">
                <b-button variant="primary" block href="#/pages/login" class="py-2">
                  <i class="fa fa-arrow-left mr-2"></i> {{ $t('BackToLogin') || 'Volver al Inicio de Sesión' }}
                </b-button>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Forget'
  }
</script>
